import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { websocket } from "./sagas/websocket";

import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";

// Middleware
const sagaMiddleware = createSagaMiddleware();
const middleware = [thunk, sagaMiddleware];
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
sagaMiddleware.run(websocket);

export default store;
